import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4 20v-8a2 2 0 0 1 2-2V8a6 6 0 1 1 12 0v2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2M14 7.5a2 2 0 1 0-4 0V10h4zM10 15a2 2 0 1 1 3 1.732V18a1 1 0 1 1-2 0v-1.268A2 2 0 0 1 10 15",
      clipRule: "evenodd"
    }
  )
);
var SvgLockedFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var LockedFilled_default = SvgLockedFilled;

export { LockedFilled_default as default };
